function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "_clipPath_3S56pwsnOddJF5KmsiOs8NMxiXIFcxfx"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 39.41 549.484 L 116.094 549.484 L 116.094 496.552 L 39.41 496.552 L 39.41 549.484 Z ",
  fill: "rgb(255,255,255)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#_clipPath_3S56pwsnOddJF5KmsiOs8NMxiXIFcxfx)"
}, /*#__PURE__*/React.createElement("path", {
  d: " M 39.41 549.484 L 116.095 549.484 L 116.095 496.552 L 39.41 496.552 L 39.41 549.484 Z ",
  fill: "rgb(255,255,255)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 92.784 515.69 L 116.095 498.905 L 116.095 496.552 L 114.075 496.552 L 86.659 515.69 L 92.784 515.69 Z ",
  fill: "rgb(235,60,33)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 91.402 531.407 L 116.095 548.979 L 116.095 545.468 L 97.53 531.407 L 91.402 531.407 Z ",
  fill: "rgb(235,60,33)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 39.41 500.581 L 59.669 515.689 L 65.8 515.689 L 39.41 497.066 L 39.41 500.581 Z ",
  fill: "rgb(235,60,33)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 64.409 531.407 L 39.409 549.177 L 39.409 549.483 L 45.006 549.483 L 70.542 531.407 L 64.409 531.407 Z ",
  fill: "rgb(235,60,33)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 110.028 496.552 L 84.971 496.552 L 84.971 514.346 L 110.028 496.552 Z ",
  fill: "rgb(2,99,196)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 71.268 496.552 L 46.335 496.552 L 71.268 514.346 L 71.268 496.552 Z ",
  fill: "rgb(2,99,196)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 116.095 515.69 L 116.095 503.546 L 101.02 515.69 L 116.095 515.69 Z ",
  fill: "rgb(2,99,196)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 116.095 543.421 L 116.095 531.407 L 101.02 531.407 L 116.095 543.421 Z ",
  fill: "rgb(2,99,196)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 48.089 549.484 L 71.268 549.484 L 71.268 532.757 L 48.089 549.484 Z ",
  fill: "rgb(2,99,196)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 84.971 549.484 L 108.242 549.484 L 84.971 532.757 L 84.971 549.484 Z ",
  fill: "rgb(2,99,196)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 39.41 531.407 L 39.41 543.963 L 55.217 531.407 L 39.41 531.407 Z ",
  fill: "rgb(2,99,196)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 39.41 515.69 L 55.217 515.69 L 39.41 503.117 L 39.41 515.69 Z ",
  fill: "rgb(2,99,196)"
}), /*#__PURE__*/React.createElement("path", {
  d: " M 74.009 496.552 L 74.009 518.834 L 39.409 518.834 L 39.409 528.271 L 74.009 528.271 L 74.009 549.484 L 82.23 549.484 L 82.23 528.271 L 116.094 528.271 L 116.094 518.834 L 82.23 518.834 L 82.23 496.552 L 74.009 496.552 Z ",
  fill: "rgb(235,60,33)"
}));

function SvgUnitedKingdomFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      isolation: "isolate"
    },
    viewBox: "39.41 496.552 76.684 52.932",
    width: "76.684pt",
    height: "52.932pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdomFlag);
export default __webpack_public_path__ + "static/media/united_kingdom_flag.e072e503.svg";
export { ForwardRef as ReactComponent };